import { useState } from 'react';
import Sheet from 'react-modal-sheet';
import close from '../assets/yettel-close.png';
import { useFetchNewsletter } from '../hooks/useFetchNewsletter.ts';
import Button from './Button.tsx';
import '../scss/newsletter-modal.scss';

interface NewsletterModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const NewsletterModal: React.FC<NewsletterModalProps> = ({ isOpen, onClose }) => {
  const { data: newsletter } = useFetchNewsletter();

  if (!newsletter) return null;

  return (
    <Sheet isOpen={isOpen} onClose={onClose} className="newsletter-modal">
      <Sheet.Container>
        <Sheet.Content>
          <NewsletterContent onCloseNewsletterPopup={onClose} url={newsletter.url} />
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={onClose} />
    </Sheet>
  );
};

interface NewsletterContentProps {
  onCloseNewsletterPopup: () => void;
  url: string;
}

const NewsletterContent: React.FC<NewsletterContentProps> = ({ onCloseNewsletterPopup, url }) => {
  return (
    <div className="content" onClick={e => e.stopPropagation()}>
      <img className="close-icon" src={close} alt="close" onClick={onCloseNewsletterPopup} width="30" height="30" />
      <iframe src={url} />
    </div>
  );
};

export const NewsletterButtonAndModal = () => {
  const { data: newsletter } = useFetchNewsletter();

  const [isNewsletterModalActive, setIsNewsletterModalActive] = useState(false);

  if (!newsletter) return null;

  return (
    <div className="newsletter-button-holder">
      <Button secondary className="text-center" onClick={() => setIsNewsletterModalActive(true)}>
        Y. Shopping katalog
      </Button>
      <NewsletterModal isOpen={isNewsletterModalActive} onClose={() => setIsNewsletterModalActive(false)} />
    </div>
  );
};
